import React from 'react';
import '../styles/AboutMeSection.css';
import SocialIcons from './SocialIcons';
import Button from './Button';
import Section from './Section';

const AboutMeSection: React.FC = () => {
  const handleResumeClick = () => {
    window.open('/resume', '_blank');
  };

  return (
    <Section id="about-me" className="about-me" title="About Me">
      <div className="about-me-content">
        <div className="profile-picture">
          <img src="/images/sweet_about.png" alt="Me" />
          <SocialIcons />
        </div>
        <div>
          <p>
            I&apos;m a full-stack software developer and University of Waterloo
            Computer Engineering graduate with experience building backend
            services, cloud-deployed applications, robotics software, and
            hardware-integrated systems. Across my work and projects, I&apos;ve
            used Python, Django, TypeScript, Node.js, PostgreSQL, Docker, and
            AWS.
          </p>
          <p>
            In my free time, I enjoy channeling my creativity into building fun,
            innovative projects — whether it&apos;s a robot, a new application,
            or even composing music.
          </p>
          <Button label="Get My Resume" onClick={handleResumeClick} />
        </div>
      </div>
    </Section>
  );
};

export default AboutMeSection;
